import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('FAMILY SERVICE');

@Injectable({
  providedIn: 'root'
})
export class FamilyService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'families' como el nombre del recurso a la clase base
    super('families');
    log.debug('Servicio de Familias inicializado');
  }

}

